module.exports = __webpack_public_path__ + "img/logo.d0b7a83f.png";